enum Color {
	Blue = "Blue",
	Green = "Green",
	Orange = "Orange",
	Red = "Red",
	Grey = "Grey"
}

export default Color;
